enum ProductListEvents {
  ProductItemClick = 'catalog_product_tap',
  FilterClick = 'filter_tap',
}

export default ProductListEvents
